<template>
    <div v-if="value" class="drawResultModal">
        <ResultModal v-model="value" v-bind="drawResult" @close="close">
            <template #cover>
                <img class="cover" :src="drawResult.cover" />
            </template>
        </ResultModal>
    </div>
</template>

<script>
import ResultModal from '../ResultModal/index.vue';

export default {
    name: 'DrawResultModal',
    components: {
        ResultModal
    },
    props: {
        value: {
            required: true,
            type: Boolean,
            default: false
        },
        drawResult: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {};
    },
    methods: {
        close() {
            this.$emit('input', false);
        }
    }
};
</script>

<style lang="less" scoped>
.drawResultModal {
    .cover {
        display: block;
        margin: 0 auto 20px;
        height: 160px;
        object-fit: contain;
    }
}
</style>
